import {dynamic} from '@github-ui/dynamic'
import {withLazyAppBoundary} from '@github-ui/react-core/lazy-app-boundary'
import type {RepoAgentsRouteComponents} from './create-repo-agents-routes'

export const lazyRepoAgentsRouteComponents: RepoAgentsRouteComponents = {
  RepoAgentsPage: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.RepoAgentsPage}
    }),
  ),
  TaskSuspended: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.TaskSuspended}
    }),
  ),
  AutomationsPage: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.AutomationsPage}
    }),
  ),
  AutomationGroupsPage: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.AutomationGroupsPage}
    }),
  ),
  AutomationDetailPage: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.AutomationDetailPage}
    }),
  ),
  AutomationHistoryPage: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.AutomationHistoryPage}
    }),
  ),
  AutomationRunsPage: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.AutomationRunsPage}
    }),
  ),
  EditAutomationPage: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.EditAutomationPage}
    }),
  ),
  NewAutomationPage: withLazyAppBoundary(
    dynamic(async () => {
      const module = await import('./route-components')
      return {default: module.NewAutomationPage}
    }),
  ),
}
